import { PageFrame } from "../components/PageFrame";
import { Reveal } from "../components/Reveal";
import { TrainerGrid } from "../components/TrainerGrid";
import { aboutParagraphs } from "../content/siteContent";

export function TrainersPage() {
  return (
    <PageFrame
      className="trainers-page"
      label="ΑΣΟ ΩΜΕΓΑ"
      title="Εκπαιδευτές"
      intro={<p>{aboutParagraphs[3]}</p>}
    >
      <Reveal className="trainers-panel technical-frame">
        <TrainerGrid />
      </Reveal>
    </PageFrame>
  );
}
